import React,{ useState, useEffect } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import {
    TextField,
    Button,
    Typography,
    Box,
    Alert,
    Stack,
} from "@mui/material";

const Login = () => {
    const [form, setForm] = useState({ email: "", password: "" });
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");
    const navigate = useNavigate();
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;


    // Redirect if token exists
    useEffect(() => {
        const token = localStorage.getItem("token");
        if (token) {
            navigate("/dashboard");
        }
    }, [navigate]);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
        setMessage("");
        setError("");
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage("");
        setError("");
        try {
            const params = new URLSearchParams();
            params.append("username", form.email);
            params.append("password", form.password);

            const res = await axios.post(
                `${API_BASE_URL}/users/login`, params,
                {headers: { "Content-Type": "application/x-www-form-urlencoded" },}
            );
            localStorage.setItem("token", res.data.token.access_token);
            localStorage.setItem("user", JSON.stringify(res.data.user));
            localStorage.setItem("role", JSON.stringify(res.data.user.role));
            setMessage("Login successful!");
            navigate("/dashboard");
        } catch (err) {
            const detail = err.response?.data?.detail;
            if (Array.isArray(detail)) {
                const messages = detail
                    .map((e) => {
                        const field = e.loc && e.loc.length > 1 ? e.loc[1] : "field";
                        return `${field}: ${e.msg}`;
                    })
                    .join(", ");
                setError(messages);
            } else {
                setError(detail || "Request failed.");
            }
        }
    };

    return (
        <Box
            maxWidth={400}
            mx="auto"
            mt={8}
            p={4}
            boxShadow={3}
            borderRadius={2}
            bgcolor="background.paper"
        >
            <Typography variant="h4" component="h1" mb={3} textAlign="center">
                Login
            </Typography>

            {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}
            {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

            <form onSubmit={handleSubmit}>
                <Stack spacing={2}>
                    <TextField
                        label="Email"
                        type="email"
                        name="email"
                        value={form.email}
                        onChange={handleChange}
                        required
                        fullWidth
                    />
                    <TextField
                        label="Password"
                        type="password"
                        name="password"
                        value={form.password}
                        onChange={handleChange}
                        required
                        fullWidth
                    />
                    <Button variant="contained" type="submit" fullWidth>
                        Login
                    </Button>
                </Stack>
            </form>

            <Box mt={3} textAlign="center" fontSize="0.9rem" color="text.secondary">
                <Typography>
                    <Link
                        to="/register"
                        style={{ color: "#1976d2", textDecoration: "underline" }}
                    >
                        Register User
                    </Link>
                </Typography>
                <Typography mt={1}>
                    <Link
                        to="/forgot-password"
                        style={{ color: "#1976d2", textDecoration: "underline" }}
                    >
                        Forgot Password?
                    </Link>
                </Typography>
                <Typography mt={1}>
                    <Link
                        to="/reset-password"
                        style={{ color: "#1976d2", textDecoration: "underline" }}
                    >
                        Reset Password
                    </Link>
                </Typography>
            </Box>
        </Box>
    );
};

export default Login;
